// @flow
import { media } from '~/core/utils/style';
import styled from 'styled-components';

const mobileMargin = '1rem';
const tabletMargin = '1.5rem';
const desktopMargin = '2rem';
const xlargeMargin = '3rem';

const sideMargin = '1rem';

export const FirstRow = styled.div`
    clear: both;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 0 calc(${mobileMargin} / 2) calc(${mobileMargin} / 2);

    ${media.tablet`
		margin: 0 calc(${tabletMargin} / 2) calc(${tabletMargin} / 2);
	`};

    ${media.desktop`
        align-items: stretch;
        flex-direction: row;
		margin: 0 calc(${desktopMargin} / 2) calc(${desktopMargin} / 2);
	`};

    ${media.xlarge`
		margin: 0 calc(${xlargeMargin} / 2) calc(${xlargeMargin} / 2);
	`};
`;

export const ProductState = styled.div`
    border-right: none;
    max-width: 30rem;
    min-width: ${p => p.theme.viewportMinWidth};
    padding: 0 1em;
    width: 100%;

    ${media.tablet`
		padding-right: 0.5rem;
	`} ${media.desktop`
        border-right: ${p => (p.rightLine ? `1px solid ${p.theme.productBorderColor}` : 'none')};
        flex: 1 0 ${p => p.theme.viewportMinWidth};
		padding-right: 1rem;
	`};
`;

export const ScheduleLayout = styled.div`
    padding: 0;
    width: 100%;

    ${media.tablet`
		padding-left: 0.5rem;
	`} ${media.desktop`
        flex: 4 0 ${p => p.theme.viewportMinWidth};
		max-width: 70rem;
		padding-left: 1rem;
	`};
`;

export const GraphLayout = styled.div`
    min-width: ${({ theme }) => theme.viewportMinWidth};
    padding: ${mobileMargin} 0;

    ${media.tablet`
		padding: ${tabletMargin} 0;
	`} ${media.desktop`
		padding: ${desktopMargin} 0;
	`} ${media.xlarge`
		padding: ${xlargeMargin} 0;
	`};
`;

export const RecipesAreaContainer = styled.div`
    display: flex;
    justify-content: center;
    min-width: ${({ theme }) => `calc(${theme.viewportMinWidth} - 2 * ${sideMargin})`};

    & > * {
        width: 100%;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/layouts/product-page/styles.js